import {
  BoxProps,
  Button,
  Spacer,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { InfoPopup } from '@/imports/ui/components/InfoPopup';

export const EditableCard: React.FC<
  {
    title: string;
    subtitle?: string;
    titleTooltip?: string;
    onSubmit: () => void;
    onClickEdit: () => void;
    onClickCancel: () => void;
    isEditing?: boolean;
    isCancelDisabled?: boolean;
    isSubmitLoading?: boolean;
    isEditButtonHidden?: boolean;
  } & BoxProps
> = ({
  title,
  titleTooltip,
  onSubmit,
  onClickEdit,
  onClickCancel,
  isEditing,
  isCancelDisabled,
  isSubmitLoading,
  isEditButtonHidden,
  children,
  subtitle,
  ...boxProps
}) => {
  return (
    <Card
      padding="6"
      as="form"
      noValidate
      onSubmit={(event: React.FormEvent) => {
        event.preventDefault();
      }}
      {...boxProps}
    >
      <Stack spacing="6">
        <Stack direction="row" alignItems="center">
          <VStack alignItems={'left'}>
            <Text textStyle="xlBodyStrong">{title}</Text>
            {titleTooltip && <InfoPopup info={titleTooltip} />}
            {subtitle && (
              <Text textStyle="compact" color="gray.500" w="full">
                {subtitle}
              </Text>
            )}
          </VStack>
          <Spacer />
          {!isEditButtonHidden && (
            <Button
              visibility={isEditing ? 'hidden' : undefined}
              onClick={onClickEdit}
              colorScheme="gray"
              variant="outline"
            >
              Edit
            </Button>
          )}
        </Stack>

        {children}

        {isEditing && (
          <Stack direction="row" justifyContent="flex-end">
            <Button
              type="button"
              variant="outline"
              colorScheme="gray"
              onClick={onClickCancel}
              isDisabled={isCancelDisabled}
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={onSubmit}
              isLoading={isSubmitLoading}
              isDisabled={isSubmitLoading}
            >
              Save Changes
            </Button>
          </Stack>
        )}
      </Stack>
    </Card>
  );
};
